import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _ImageMachine;
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbFilterUtils } from "abreact/utils/AbFilterUtils";
import { AbWebServices } from "abweb/service/AbWebServices";
import { action, computed, makeObservable, observable } from "mobx";
var FILTER_FUNCTIONS = AbFilterUtils.FILTER_FUNCTIONS;
export let OnClickActionEnum = /*#__PURE__*/function (OnClickActionEnum) {
  OnClickActionEnum[OnClickActionEnum["INFOBUBBLE"] = 0] = "INFOBUBBLE";
  OnClickActionEnum[OnClickActionEnum["SELECT_IMAGE"] = 1] = "SELECT_IMAGE";
  return OnClickActionEnum;
}({});
export let ImageMachine = (_class = (_ImageMachine = class ImageMachine {
  constructor(codeExampleFunction, onImageSelect, hideLightbox, hideContextButtons, onClickAction, additionalNamespaces, imageFilter) {
    _defineProperty(this, "_allImages", []);
    _defineProperty(this, "_namespaceList", []);
    _initializerDefineProperty(this, "_namespace", _descriptor, this);
    _initializerDefineProperty(this, "_rendering", _descriptor2, this);
    _initializerDefineProperty(this, "_familyMenuChoice", _descriptor3, this);
    _initializerDefineProperty(this, "_subfamilyMenuChoice", _descriptor4, this);
    _initializerDefineProperty(this, "_visibleImages", _descriptor5, this);
    _initializerDefineProperty(this, "icons", _descriptor6, this);
    // family ==> ( subfamily ==> image array )
    _initializerDefineProperty(this, "_selectedImages", _descriptor7, this);
    _initializerDefineProperty(this, "_searchTerm", _descriptor8, this);
    _initializerDefineProperty(this, "defaultImageSize", _descriptor9, this);
    _initializerDefineProperty(this, "grouped", _descriptor10, this);
    // always true. Previously optionally grouped semantic names. Now we always group sizes.
    _initializerDefineProperty(this, "showDeprecated", _descriptor11, this);
    _defineProperty(this, "_hideLightbox", void 0);
    _defineProperty(this, "_hideContextButtons", void 0);
    // show/hide all context buttons
    _defineProperty(this, "_onClickAction", void 0);
    // what happens when the user clicks on an image?
    _defineProperty(this, "_namespaces", void 0);
    _defineProperty(this, "imageFilter", void 0);
    _defineProperty(this, "codeExampleFunction", null);
    _defineProperty(this, "imageGridBox", null);
    /** matches on semantic name if it exists, else the display name
     supports the usecase of OnClickActionEnum.SELECT_IMAGE for AbIconInput
     This is a temporary fix. Should probably make a new component as this file is meant to be internal.
     **/
    _defineProperty(this, "simpleMatch", (searchTerm, image) => {
      const key = searchTerm.toLowerCase();
      const identifierInfo = AbWebServices.getImageIdentifierManager().getIdentifierInfo(image);
      const semanticName = identifierInfo.extra?.semanticName;
      return semanticName ? FILTER_FUNCTIONS.SUBSTRING(key, semanticName.toLowerCase()) : FILTER_FUNCTIONS.SUBSTRING(key, image.toLowerCase());
    });
    makeObservable(this);
    this._namespace = "";
    this._rendering = "";
    this._familyMenuChoice = "All";
    this._subfamilyMenuChoice = null;
    this._visibleImages = [];
    this.icons = null;
    this._selectedImages = [];
    this._searchTerm = "";
    this.defaultImageSize = 32;
    this.grouped = true;
    this.showDeprecated = false;
    this._hideLightbox = hideLightbox === undefined ? false : hideLightbox;
    this._hideContextButtons = hideContextButtons === undefined ? false : hideContextButtons;
    this._onClickAction = onClickAction === undefined ? OnClickActionEnum.INFOBUBBLE : onClickAction;
    this._namespaces = additionalNamespaces;
    this.imageFilter = imageFilter;
    if (codeExampleFunction) {
      this.codeExampleFunction = codeExampleFunction;
    }
    if (onImageSelect) {
      this.onImageSelect = onImageSelect;
    }
    this.init();
  }

  /**
   * Used to determine if an arbitrary namespace can be used
   * in AbIconPicker/AbIconInput components.
   * By default, only "absdk" and customer-defined namespaces are to be used.
   */
  static isExcludedNamespace(namespace, excludeAbSdk) {
    if (namespace === "absdk") {
      return !!excludeAbSdk;
    }
    return ImageMachine.AB_NAMESPACES.indexOf(namespace) !== -1;
  }
  get query() {
    return this.namespace + this._searchTerm;
  }
  get hideLightbox() {
    return this._hideLightbox;
  }
  get namespaces() {
    return this._namespaces;
  }
  get hideContextButtons() {
    return this._hideContextButtons;
  }
  get onClickAction() {
    return this._onClickAction;
  }
  get allImagesCount() {
    return this._allImages.length;
  }
  get allImages() {
    return this._allImages;
  }
  get namespaceList() {
    return this._namespaceList;
  }
  imageExists(image) {
    return this._allImages.indexOf(image) !== -1;
  }
  getImageAtIndex(index) {
    return this._visibleImages[index];
  }

  // How many images are visible now?
  get visibleImageCount() {
    return this._visibleImages.length;
  }
  get selectedImages() {
    return this._selectedImages;
  }

  // Are there images in the Lightbox?
  get hasLightboxImages() {
    return this._selectedImages.length > 0;
  }
  forceUpdateGrid() {
    this.imageGridBox?.forceUpdateGrid();
  }
  changeGrouped(grouped) {
    this.grouped = grouped;
    this.calculateVisibleImages();
    this.forceUpdateGrid();
  }
  changeShowDeprecated(showDeprecated) {
    this.showDeprecated = showDeprecated;
    this.calculateVisibleImages();
    this.forceUpdateGrid();
  }
  init() {
    // Push all ImageIdentifierInfo "namespace:id" strings into array, then default sort
    AbWebServices.getImageIdentifierManager().getImageIdentifierService().getAllIdentifiers().forEach(image => {
      // Filter out images that are on not on the namespace List
      if (this._namespaces && !this._namespaces.includes(image.namespace) || image.namespace === "litebrite") {
        return;
      }
      if (this.imageFilter && !this.imageFilter(image)) {
        return;
      }

      // Add namespaces to create namespace buttons
      if (this._namespaceList.indexOf(image.namespace) === -1) {
        this._namespaceList.push(image.namespace);
      }
      let name = image.namespace + ":" + image.id;
      this._allImages.push(name);
    });
    this._namespaceList.sort();
    this._allImages.sort();
    this._visibleImages = this._allImages;

    // Only resurrect Lightbox images if we're using the Lightbox
    if (!this.hideLightbox) {
      // Initialize sessionStorage for Lightbox
      if (sessionStorage.dojo_image_finder_lightbox !== undefined) {
        this._selectedImages = JSON.parse(sessionStorage.dojo_image_finder_lightbox);
      }
      sessionStorage.dojo_image_finder_lightbox = JSON.stringify(this._selectedImages);
    }
  }

  // Create namespace toggle buttons
  getNamespaceButtons() {
    let buttons = [{
      label: "All",
      value: ""
    }];
    this._namespaceList.forEach(namespace => {
      buttons.push({
        label: namespace,
        value: namespace
      });
    });
    return buttons;
  }

  // Is the selected image in the Lightbox?
  isSelectedImage(image) {
    return this._selectedImages.indexOf(image) !== -1;
  }

  // Is the selected image wide?
  static isWideImage(image) {
    return ImageMachine.wideImages.indexOf(image) !== -1;
  }

  // Is the selected image blank?
  static isBlankImage(image) {
    return ImageMachine.blankImages.indexOf(image) !== -1;
  }
  set searchTerm(searchTerm) {
    this._searchTerm = searchTerm;
    this.calculateVisibleImages();
  }
  get searchTerm() {
    return this._searchTerm;
  }
  // Main method to filter out images based on namespace and search term
  calculateVisibleImages() {
    if (this.onClickAction === OnClickActionEnum.SELECT_IMAGE) {
      this._visibleImages = this._allImages.filter(image => this.simpleMatch(this.searchTerm, image));
    } else {
      this._visibleImages = this._allImages.filter(image => this._namespace ? this.isInNamespace(image, this._namespace) : true).filter(image => this.isntDeprecated(image, this.showDeprecated)).filter(image => this.familyMatches(image, this._familyMenuChoice, this._subfamilyMenuChoice)).filter(image => this.searchTermMatches(this._searchTerm, image));
      if (this.namespace === "absdk") {
        // order the visible icons.
        // We build a map from family => a submap, and each submap is from subfamily => icon array.
        this.icons = new Map();
        for (const image of this._visibleImages) {
          const identifierInfo = AbWebServices.getImageIdentifierManager().getIdentifierInfo(image);
          const sdkInfo = identifierInfo.extra;
          if (sdkInfo === null) {
            // no icon info? not in the icons.
            continue;
          }
          // An icon can have more than one family.  Add to all appropriate maps and submaps
          for (const family of sdkInfo.family) {
            // If user has chosen a family and subfamily, then the icons list should only use that information.
            if (this._familyMenuChoice !== "All" && family.first.indexOf(this._familyMenuChoice) < 0 || this._subfamilyMenuChoice !== null && family.second.indexOf(this._subfamilyMenuChoice) < 0) continue;
            // Use first to look up the subfamily map, or create it if necessary
            if (!this.icons.has(family.first)) {
              this.icons.set(family.first, new Map());
            }
            const subfamilyMap = this.icons.get(family.first);
            // Use second to look up icon array, or create it if necessary
            if (!subfamilyMap.has(family.second)) {
              subfamilyMap.set(family.second, []);
            }
            // Add to icon array
            subfamilyMap.get(family.second).push(sdkInfo);
          }
        }
      }
      if (this.grouped) {
        // show the only 16px size with the same SemanticName.
        // maps semanticName ==> visible image key
        let map = new Map();

        // walk all the images to fill map: SemanticName -> shortest key
        for (const image of this._visibleImages) {
          const identifierInfo = AbWebServices.getImageIdentifierManager().getIdentifierInfo(image);
          const sdkInfo = identifierInfo.extra;
          if (sdkInfo === null) {
            continue;
          }
          const old = map.get(sdkInfo.semanticName);
          if (old == null || sdkInfo.size === "") {
            // We found a new semantic name, or the new image with the same semantic name is better
            map.set(sdkInfo.semanticName, sdkInfo.key);
          }
        }
        if (this.icons) {
          // walk all the icons again, and if an image is not in the map, remove it
          for (const [first, innerMap] of this.icons.entries()) {
            for (const [second, images] of innerMap.entries()) {
              images.forEach((image, index) => {
                if (map.get(image.semanticName) !== image.key) {
                  if (0)
                    // remove the image, the map has a image with the same semantic name and a better key
                    console.warn(`Image Viewer: not showing image '${image.key}' because '${map.get(image.semanticName)}' has same semantic name '${image.semanticName}'`);
                  images.splice(index, 1);
                }
              });
            }
          }
        }

        // walk all images again, and if an image is not in the map, remove it
        let n = this._visibleImages.length;
        for (let i = 0; i < n; i++) {
          const image = this._visibleImages[i];
          const identifierInfo = AbWebServices.getImageIdentifierManager().getIdentifierInfo(image);
          const sdkInfo = identifierInfo.extra;
          if (sdkInfo === null) {
            continue;
          } // not AbSDK: keep it
          if (map.get(sdkInfo.semanticName) === sdkInfo.key) {
            continue;
          } // its in map: keep it
          this._visibleImages.splice(i, 1); // remove it
          n--;
          i--;
        }
      }
    }
  }
  isntDeprecated(image, showDeprecated) {
    if (showDeprecated) return true; // we are showing everything
    const identifierInfo = AbWebServices.getImageIdentifierManager().getIdentifierInfo(image);
    const sdkInfo = identifierInfo.extra;
    if (sdkInfo === null) {
      return true;
    } // no sdk, it isn't deprecated

    return sdkInfo.flags.indexOf("deprecated") === -1;
  }
  familyMatches(image, familyMenuChoice, subfamilyMenuChoice) {
    if (familyMenuChoice === "All") {
      return true;
    }
    const identifierInfo = AbWebServices.getImageIdentifierManager().getIdentifierInfo(image);
    const sdkInfo = identifierInfo.extra;
    if (sdkInfo === null) {
      return true;
    } // no sdk, it matches

    const imageFamilies = sdkInfo.family;
    let foundIt = false;
    imageFamilies.forEach(fam => {
      if (fam.first.indexOf(familyMenuChoice) >= 0 && (subfamilyMenuChoice === null || fam.second.indexOf(subfamilyMenuChoice) >= 0)) foundIt = true;
    });
    return foundIt;
  }
  searchTermMatches(searchTerm, image) {
    const key = searchTerm.toLowerCase();
    // check image name
    if (image.toLowerCase().indexOf(key) !== -1) {
      return true;
    }

    // check SDK info
    const identifierInfo = AbWebServices.getImageIdentifierManager().getIdentifierInfo(image);
    const sdkInfo = identifierInfo.extra;
    if (sdkInfo === null) {
      return false;
    }
    function matches(x) {
      return x != null && x.some(el => el != null && el.toLowerCase().indexOf(key) !== -1);
    }
    function familyMatches(x) {
      return x != null && x.some(el => el != null && (el.first.toLowerCase().indexOf(key) >= 0 || el.second.toLowerCase().indexOf(key) >= 0));
    }
    return matches([sdkInfo.semanticName]) || matches(sdkInfo.usage) || familyMatches(sdkInfo.family) || matches(sdkInfo.visualElement) || matches([sdkInfo.notes]);
  }

  // Is the selected image in the selected namespace?
  isInNamespace(image, namespace) {
    return image.indexOf(namespace + ":") === 0;
  }
  set namespace(buttonValue) {
    // Only change namespace if it has changed.
    if (buttonValue !== this._namespace) {
      // Update instance variable
      this._namespace = buttonValue;
      this.icons = null;
      this.calculateVisibleImages();
    }
  }
  get namespace() {
    return this._namespace;
  }
  set rendering(buttonValue) {
    if (buttonValue !== this._rendering) {
      this._rendering = buttonValue;
      this.forceUpdateGrid();
    }
  }
  get rendering() {
    return this._rendering;
  }
  setFamily(first, second) {
    if (first === this._familyMenuChoice && second === this._subfamilyMenuChoice) return;
    this._familyMenuChoice = first;
    this._subfamilyMenuChoice = second;
    this.calculateVisibleImages();
    this.forceUpdateGrid();
  }
  getCurrentFamily() {
    return this._familyMenuChoice + (this._subfamilyMenuChoice != null ? ": " + this._subfamilyMenuChoice.substring(0, 1).toUpperCase() + this._subfamilyMenuChoice.substring(1) : "");
  }

  /**
   *  Adds/removes images from the Lightbox.
   */
  handleOnImageSelect(image) {
    if (this.onClickAction === OnClickActionEnum.INFOBUBBLE) {
      return;
    }

    // Clear lightbox and add image
    this._selectedImages = [];
    this._selectedImages.push(image);
    this.onImageSelect(image);
  }

  /**
   *  Adds/removes images from the Lightbox.
   */
  toggleLightbox(image) {
    if (this.onClickAction === OnClickActionEnum.SELECT_IMAGE) {
      return;
    }

    // if image is lightbox, remove from list
    if (this.isSelectedImage(image)) {
      this._selectedImages = this._selectedImages.filter(selectedImage => {
        return selectedImage !== image;
      });
    } else {
      this._selectedImages.push(image);
    }

    // Persist Lightbox in sessionStorage
    sessionStorage.dojo_image_finder_lightbox = JSON.stringify(this._selectedImages);
  }
  onDefaultImageSizeChange(event) {
    this.defaultImageSize = event.target.value;
  }
}, _defineProperty(_ImageMachine, "IMAGE_MIN", 16), _defineProperty(_ImageMachine, "IMAGE_MAX", 80), _defineProperty(_ImageMachine, "AB_NAMESPACES", ["ab", "absdk", "abpv", "abvdl", "test", "tl"]), _defineProperty(_ImageMachine, "wideImages", ["ab:abinitioLogo", "absdk:abinitio-logo", "ab:defaultApplicationBanner", "ab:poweredByAbInitio", "ab:powered_by_abinitio", "ab:powered_by_abinitio_alt", "abpv:navGrip", "ab:expressitLoginSplash"]), _defineProperty(_ImageMachine, "blankImages", ["ab:abinitioLogo", "ab:jobStatusRedacted16x16", "ab:noIssue16x16", "ab:noIssue40x40", "ab:xxg_detail_layer_digital_signature"]), _ImageMachine), _descriptor = _applyDecoratedDescriptor(_class.prototype, "_namespace", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_rendering", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_familyMenuChoice", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_subfamilyMenuChoice", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_visibleImages", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "icons", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_selectedImages", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_searchTerm", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "defaultImageSize", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "grouped", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "showDeprecated", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "query", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "query"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "visibleImageCount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "visibleImageCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasLightboxImages", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasLightboxImages"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeGrouped", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeGrouped"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeShowDeprecated", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeShowDeprecated"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "init", [action], Object.getOwnPropertyDescriptor(_class.prototype, "init"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "calculateVisibleImages", [action], Object.getOwnPropertyDescriptor(_class.prototype, "calculateVisibleImages"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFamily", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFamily"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleOnImageSelect", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleOnImageSelect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleLightbox", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleLightbox"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDefaultImageSizeChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDefaultImageSizeChange"), _class.prototype), _class);
//# sourceMappingURL=ImageMachine.js.map
